module.exports = __webpack_public_path__ + "static/Football-15501fa4bfb1b533394f4f1524382e56.mp4";